import moment from "moment";

export function secondsToTime(
  totalSeconds: number,
  forVisualAid: boolean,
  includeSecondsAtEnd?: boolean
): string {
  let total = totalSeconds;

  // Hours
  const hours = Math.floor(total / 3600);
  if (hours > 0) total -= hours * 3600;

  // Minutes
  const minutes = Math.floor(total / 60);
  if (minutes > 0) total -= minutes * 60;

  let stringMinutes = `0${minutes}`;
  if (minutes > 9) stringMinutes = `${minutes}`;

  const seconds = total;

  // Will say x hours x minutes x seconds, instead of hh:mm:ss
  if (forVisualAid) {
    if (hours > 0) {
      if (hours === 1) return `${hours} hour ${stringMinutes} minutes`;
      return `${hours} hours:${stringMinutes}`;
    } else if (minutes > 0) {
      if (Number(stringMinutes) === 1) return `${stringMinutes} minute`;
      return `${stringMinutes} minutes`;
    } else {
      if (seconds === 1) return `${seconds} second`;
      return `${seconds} seconds`;
    }
  }

  // includes :00 seconds at end
  if (includeSecondsAtEnd) {
    if (hours > 0) return `${hours}:${stringMinutes}:${seconds}`;
    if (seconds < 1) return "00:00";
    if (seconds < 10) return `${stringMinutes}:0${seconds}`;
    else return `${stringMinutes}:${seconds}`;
  }

  if (hours > 0) return `${hours}:${stringMinutes}`;
  else return `00:${stringMinutes}`;
}

// Takes in time formatted as hh:mm:ss
export function timeToSeconds(time: string): number {
  let totalSeconds = 0;
  const splitTime: string[] = time.split(":");
  totalSeconds += Number(splitTime[0]) * 3600;
  totalSeconds += Number(splitTime[1]) * 60;
  totalSeconds += Number(splitTime[2]);
  return totalSeconds;
}

export function getNowInUnix(): number {
  return moment().unix();
}

export function didDaysAgo(dateInUnix: number | null): string {
  if (dateInUnix) {
    const lastDoneMoment = moment.unix(dateInUnix);
    const daysLastDone = String(moment().diff(lastDoneMoment, "days"));
    if (Number(daysLastDone) === 0) return "Done Today";
    return `Did ${daysLastDone} days ago`;
  }
  return "Not Done";
}

export function unixTimeToReadableDate(timeStampUnix: number): string {
  return moment.unix(timeStampUnix).format("MMMM Do, h:mm a");
}
